import script from "./rainCoinOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./rainCoinOverlay.vue?vue&type=script&setup=true&lang=ts"

import "./rainCoinOverlay.vue?vue&type=style&index=0&id=5bd280b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bd280b4"]])

export default __exports__